import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule } from '@progress/kendo-angular-grid';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { SharedModule } from '../../shared/shared.module';
import { IssueService } from '../issue/service/issue.service';
import { EditQuestionChoiceComponent } from './components/edit-question-choice/edit-question-choice.component';
import { QuestionListComponent } from './components/question-list/question-list.component';
import { QuestionRoutingModule } from './question-routing.module';
import { QuestionService } from './service/question.service';
import { OrderModule } from 'ngx-order-pipe';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    QuestionRoutingModule,
    GridModule,
    ReactiveFormsModule,
    FormsModule,
    TooltipModule,
    OrderModule
  ],
  declarations: [QuestionListComponent, EditQuestionChoiceComponent],

  exports: [],
  providers: [QuestionService, IssueService],
  entryComponents: [QuestionListComponent]
})
export class QuestionModule {}
